// import React from 'react';
// import { Card, CardContent, Typography, Grid } from '@mui/material';
// import { IMAGE_URL } from 'network';

// const Gallery = ({ images }) => (
//   <Card>
//     <CardContent>
//       <Typography variant="h6">Gallery</Typography>
//       <Grid container spacing={1}>
//         {images.map((img) => (
//           <Grid item key={img._id}>
//             <img src={IMAGE_URL+img.imageUrl} crossOrigin="anonymous" width="150" style={{ borderRadius: 8 }} alt="cafe" />
//           </Grid>
//         ))}
//       </Grid>
//     </CardContent>
//   </Card>
// );

// export default Gallery;


import { IMAGE_URL } from "network";
import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Card, CardContent, Typography, Grid } from '@mui/material';
const Gallery = ({ images = [] }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleThumbnailClick = (index) => {
    setSelectedIndex(index);
  };

  return (
    <Card>
    <CardContent className="pt-4">
    <div className="col-lg-12">
      <div className="slideritem-active px-4">
        <Carousel
          selectedItem={selectedIndex}
          onChange={setSelectedIndex}
          showArrows={true}
          showThumbs={false}
          infiniteLoop
          emulateTouch
          showStatus={false}
        >
          {images.map((item, index) => (
            <div key={index}>
              <img src={IMAGE_URL+item.imageUrl} crossOrigin="anonymous" alt={`slide-${index}`} />
            </div>
          ))}
        </Carousel>
      </div>

      <div className="slider-next mt-4 px-3">
        <Carousel
          selectedItem={selectedIndex}
          onChange={handleThumbnailClick}
          showArrows={true}
          showIndicators={false}
          showStatus={false}
          showThumbs={false}
          centerMode
          centerSlidePercentage={25}
          infiniteLoop
        >
          {images.map((item, index) => (
            <div
              key={index}
              onClick={() => handleThumbnailClick(index)}
              style={{
                padding: "4px",
                border:
                  selectedIndex === index
                    ? "2px solid #06B66C"
                    : "2px solid transparent",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              <img
                src={IMAGE_URL+item.imageUrl}
                crossOrigin="anonymous"
                alt={`thumb-${index}`}
                style={{ height: "80px", objectFit: "cover" }}
              />
            </div>
          ))}
        </Carousel>
      </div>
    </div>
    </CardContent>
     </Card>
  );
};

export default Gallery;
